<template>
  <div class="loginBg" style="display:flex;justify-content:center;align-items: center;width: 100vw;height:100vh;">
    <div class="loginBox">
      <div
        style="font-weight: 500;font-size: 32px;color: #FFFFFF;line-height: 45px;letter-spacing: 1px;position: absolute;left:72px;top:253px">
        报表中心管理后台</div>
      <div
        style="font-weight: 500;font-size: 54px;color: #FFFFFF;line-height: 75px;letter-spacing: 2px;position: absolute;left:72px;top:160px">
        欢迎使用
      </div>
      <img src="@/assets/login_img.png" alt=""
        style="width:300px;height:300px;position: absolute;left:318px;bottom:18px">
      <div
        style="width: 424px;height: 580px;background: #FFFFFF;border-radius: 0px 18px 18px 0px;position: absolute;right: 0;">
        <div style="font-weight: 500;font-size: 30px;color: #1C88FF;margin-top:98px;text-align:center">报表中心管理后台</div>
        <div style="font-weight: 500;font-size: 16px;color: #1C88FF;margin-top:64px;margin-bottom:30px;text-align:center">账号密码登录</div>
        <div style="padding: 0 42px;" class="formBox">
          <el-input v-model="formInline.username" placeholder="请输入账号" style="margin-bottom:16px"></el-input>
          <el-input type="password" v-model="formInline.password" placeholder="请输入密码"></el-input>
          <el-button type="primary" class="login" @click="login">登录</el-button>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
  // import serialport from 'serialport'

  // import fs from 'fs'

  export default {
    name: 'App',
    data () {
      return {
        formInline: {
          username: '',
          password: ''
        }
        // breadcrumb:[]
      }
    },
    methods: {
      login () {
        this.$axios.post('/api/admin/login', this.formInline).then((res) => {
          // this.$axios.defaults.headers.common['Token'] = res.data.token;
          localStorage.setItem("total_token", res.data.token)
          this.$router.push({ path: "/productlist" })
        }, err => {
          if (err.data) {
            this.$message.error(err.data.message);
          }
        })
      }
    }
  }
</script>
<style scoped>
  .formBox /deep/.el-input .el-input__inner {
    border: none;
    border-bottom: 1px solid #C0C4CC;
    border-radius: 0;
    padding: 20px ;
  }

  body {
    margin: 0;
  }

  .login {
    width: 338px;
    height: 52px;
    background: #1C88FF;
    border-radius: 6px;
    margin-top: 64px;
  }



  .loginBox {
    width: 1060px;
    height: 580px;
    position: relative;
    background: #1C89FF;
    border-radius: 18px;
  }

  .loginBg {
    background-image: url('../../assets/login_bg.png');
    background-size: cover;
    /* 背景图片覆盖整个元素 */
    background-repeat: no-repeat;
    /* 背景图片不重复 */
    background-position: center;
    /* 背景图片居中 */
  }
</style>